import Vue from "vue";
import VueRouter from "vue-router";

import store from "./store";
import App from "./App";

Vue.use(VueRouter);

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
